'use client';

import { useTranslations } from 'next-intl';
import React from 'react';

import NewsletterForm from '@/app/[locale]/(default-layout)/(forms)/_components/NewsletterForm';

import CenterLayout from '@cineamo/composables/src/CenterLayout';

const NewsletterPageClient: React.FC = () => {
    const t = useTranslations();

    return (
        <main className="min-h-screen">
            {/* Hero Section */}
            <section className="py-24 backdrop-blur-sm bg-[rgba(var(--on-background-color-rgb),0.05)]">
                <CenterLayout>
                    <div className="text-center space-y-6 max-w-4xl mx-auto">
                        <h1 className="text-headline-48 text-[var(--on-background-color)]">
                            {t('newsletter.hero.title')}
                        </h1>
                        <p className="text-headline-20 font-semibold text-[var(--on-background-color)]">
                            {t('newsletter.hero.subtitle')}
                        </p>
                        <p className="text-body-16 max-w-3xl mx-auto text-[rgba(var(--on-background-color-rgb),0.8)]">
                            {t('newsletter.hero.description')}
                        </p>
                    </div>
                </CenterLayout>
            </section>

            {/* Newsletter Form Section */}
            <section className="py-24">
                <CenterLayout>
                    <div className="max-w-2xl mx-auto">
                        <NewsletterForm />
                    </div>
                </CenterLayout>
            </section>
        </main>
    );
};

export default NewsletterPageClient;
